import { TranslateService } from "@ngx-translate/core";
import { Observable, map, switchMap } from "rxjs";

export function resolveAppLang(translateService: TranslateService): string {
  return (
    translateService.currentLang ||
    sessionStorage.getItem("lang") ||
    "fr"
  );
}

/** Forces the translation file to load before use — fixes default French showing raw keys. */
export function ensureTranslateLangLoaded(
  translateService: TranslateService,
  lang?: string,
): Observable<string> {
  const resolvedLang = lang || resolveAppLang(translateService);
  return translateService.getTranslation(resolvedLang).pipe(
    switchMap(() => translateService.use(resolvedLang)),
    map(() => resolvedLang),
  );
}
